import {createUseStyles} from 'react-jss';
import loadArtemisFonts from '../../../v2/components/ui/loadArtemisFonts';
import isUsingArtemisStyles from '../../../v2/selectors/isUsingArtemisStyles';
import MediaQueries from '../../../v2/style-helper/MediaQueries';
import Typography from '../../../v2/style-helper/Typography';

export default createUseStyles({
  loginNewAccount: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: props => (props.isNewGuestUpdatedPage ? 'left' : 'center'),
    textAlign: props => (props.isNewGuestUpdatedPage ? 'left' : 'center'),
  },
  innerContainer: {
    maxWidth: 391,
    width: '100%',
  },
  successMessage: {
    fontSize: '1.5em',
    marginBottom: '0.75em',
    extend: props => ({
      ...(isUsingArtemisStyles && props.theme.typography?.[Typography.medium])
      && loadArtemisFonts(props.theme.typography[Typography.medium]),
    }),
  },
  accountLogin: {
    marginBottom: '0.75em',
  },
  loginButton: {
    marginBottom: 20,
    '&:last-child': {
      marginBottom: 0,
    },
    
    [MediaQueries.phone]: {
      marginBottom: '0.5em',
    },
  },
  socialSharingContainer: {
    marginTop: 40,
  
    [MediaQueries.phone]: {
      borderTop: props => props.isNewGuestUpdatedPage && 'solid 1px #ccc',
      paddingTop: props => props.isNewGuestUpdatedPage && 30,
    },
  },
});
